// @ts-strict-ignore
import { useCallback, useContext } from 'react';

import { RuleBuilderSubEditorSide } from 'flow/store/engine/types';
import { changeDescription } from 'flow/store/redux/types';
import type { WorkflowStateChange } from 'flow/store/redux/types';
import { createWorkflowHistoryThunk } from 'flow/store/redux/thunks';
import { createUiEffectContext } from 'flow/service/history';
import { Operation } from 'flow/service/changelog/types';
import { useAppDispatch, useAppSelector } from '~/store/reduxHooks';
import { selectExpressionActiveSubEditor } from 'flow/store/redux/selectors';
import { UserContext } from '~/dashboard/context';
import { MLAEditorContext } from './context';
import { MLAAttributeItemOrigin } from '../NodeEditorDrawer/types';
import { isDataRoute } from './helpers';

export function useMlaHistoryDispatch(uiEffectElementId: string) {
  const dispatch = useAppDispatch();
  const { sourceData } = useContext(MLAEditorContext);
  const { featureFlags } = useContext(UserContext);

  const expressionActiveSubEditor = useAppSelector(selectExpressionActiveSubEditor);

  return useCallback((stateChange: WorkflowStateChange) => {
    const { data } = sourceData;
    const isDataRouteOrigin = isDataRoute(data);
    const subEditorArgs = isDataRouteOrigin ? {
      dataRoute: expressionActiveSubEditor,
    } : {
      threshold: {
        publicId: data.publicId,
        side: sourceData.type === MLAAttributeItemOrigin.THRESHOLD_LEFT
          ? RuleBuilderSubEditorSide.LHS
          : RuleBuilderSubEditorSide.RHS,
      },
    };

    const actionId = isDataRouteOrigin
      ? data.targetId
      : data.actionId;

    dispatch(createWorkflowHistoryThunk(
      stateChange,
      Boolean(featureFlags?.workflowEditorUndoRedo),
      {
        operation: Operation.Modify,
        uiEffectContext: createUiEffectContext(changeDescription.mla, {
          actionId,
          htmlElementId: uiEffectElementId,
          subEditorArgs,
        }),
      },
    ));
  }, [
    dispatch,
    featureFlags?.workflowEditorUndoRedo,
    sourceData,
    uiEffectElementId,
    expressionActiveSubEditor,
  ]);
}
